module.exports = __webpack_public_path__ + "img/PL00239.3f3fa682.png";